export default __webpack_public_path__ + "static/media/star_disable.57def353.svg";